import { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { AccessibilityToolbar } from "./AccessibilityToolbar";
import { BackToTop } from "./BackToTop";

export const Layout = ({ children }: { children: ReactNode }) => (
  <div className="min-h-screen flex flex-col">
    <a
      href="#main"
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-primary focus:text-primary-foreground focus:px-4 focus:py-2 focus:rounded-md focus:shadow-elegant"
    >
      Salta al contenuto principale
    </a>
    <Header />
    <main id="main" className="flex-1">{children}</main>
    <Footer />
    <AccessibilityToolbar />
    <BackToTop />
  </div>
);
